import { Component, OnDestroy, OnInit } from "@angular/core";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { HttpEventType, HttpResponse } from "@angular/common/http";
import { AfterViewInit, ViewChild } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { FormControl, Validators } from "@angular/forms";
import { finalize } from "rxjs/operators";
import { LogImport } from "../core/model/log-import";
import { LogImportService } from "../core/service/log-import.service";
import { DetailImportationComponent } from "./detail-importation/detail-importation.component";
import { Observable, Subscription } from "rxjs";
import { ToastrService } from "ngx-toastr";
import { WebSocketService } from "src/app/core/services/WebSocket/WebSocketService";
import { NotificationConsts } from "src/app/core/models/NotificationConsts";
import { NgbdModalConfirm } from 'src/app/core/services/utils/modal-confirm';

@Component({
  selector: "app-historique-importation",
  templateUrl: "./historique-importation.component.html",
  styleUrls: ["./historique-importation.component.scss"],
})
export class HistoriqueImportationComponent implements OnInit, OnDestroy {
  private eventSubscription: Subscription;
  progress = 0;
  message = "";
  directory: string = "mise_en_place";
  selectedFiles: FileList;
  currentFile: File;
  logImports: LogImport[];
  displayedColumns: string[] = [
    "nomFichier",
    "directory",
    "dateTelechargement",
    "downloadBy",
    //"dateImportation",
    "nbLigneTrouve",
    "nbLigneImporte",

    "status",
    "actions",
  ];

  resultsLength = 0;
  isLoadingResults = true;
  isRateLimitReached = false;
  isLoadingResultsImport = true;

  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  fileControl: FormControl;
  public files;

  constructor(
    private modalService: NgbModal,
    private _logImportService: LogImportService,
    private toastrService: ToastrService,
    private webSocketService: WebSocketService
  ) {
    this.fileControl = new FormControl(this.files, [Validators.required]);
  }

  ngOnInit() {
    this.listLogImports();
    this.fileControl.valueChanges.subscribe((files: any) => {
      if (!Array.isArray(files)) {
        this.files = [files];
      } else {
        this.files = files;
      }
    });
    this.initWebSocket();
  }

  listLogImports() {
    this.isLoadingResults = true;
    this._logImportService
      .logImports()
      .pipe(finalize(() => (this.isLoadingResults = false)))
      .subscribe(
        (data) => {
          this.logImports = data;
        },
        (error) => {
          console.log(error);
        }
      );
  }

  showDetailHistory(history) {
    const modalRef = this.modalService.open(DetailImportationComponent, {
      centered: true,
      backdropClass: "light-blue-backdrop",
      backdrop: "static",
      size: "lg",
      scrollable: true,
      windowClass: "app-detail-importation",
    });

    console.log(history);

    modalRef.componentInstance.logImportId = history.id;
    modalRef.result.then(
      (result) => {
        // on close
        this.listLogImports();
      },
      (reason) => {
        console.log("reason", reason);
        // on dismiss
      }
    );
  }

  selectFile(event) {
    this.selectedFiles = event.target.files;
  }
  upload() {
    this.progress = 0;
    this.currentFile = this.selectedFiles.item(0);
    this._logImportService.upload(this.directory, this.currentFile).subscribe(
      (data) => {
        this.listLogImports();
      },
      (err) => {
        this.progress = 0;
        this.message = "Impossible de télécharger le fichier!";
        this.currentFile = undefined;
      }
    );
    this.selectedFiles = undefined;
    this.listLogImports();
  }

  typeFichierChanged() {
    
  }

  importFile(logImportId) {
    this.isLoadingResults = true;
    this._logImportService.importerFichier(logImportId).subscribe(
      (data) => {
        this.isLoadingResults = false;
        this.listLogImports();
      },
      (error) => {
        this.isLoadingResults = false;
        console.log(error);
      }
    );
    this.listLogImports();
  }

  initWebSocket() {
    // S'abonner aux événements reçus
    this.eventSubscription = this.webSocketService
      .message$
      .subscribe((message: any) => {
        if (message) {
          switch (message.typeNotification) {
            case NotificationConsts.SUIVI_PORTFEUILLE_IMPORTATION:
              this.listLogImports();
              this.toastrService.success(
                "Fichier importé avec succès",
                "Importation réussie"
              );
              break;
          }
        }
      });
  }
    // Méthode pour envoyer un message global
    sendGlobalEvent() {
      this.webSocketService.sendMessage("/app/events", {
        event: "NEW_GLOBAL_EVENT",
      });
    }
  
    // Méthode pour envoyer un message spécifique à un utilisateur
    username: string = "exempleUsername";
    sendUserEvent() {
      this.webSocketService.sendMessage(`/app/user/${this.username}/message`, {
        event: "NEW_USER_EVENT",
      });
    }
    ngOnDestroy(): void {
      // Désabonnement lorsque le composant est détruit
      if (this.eventSubscription) {
        this.eventSubscription.unsubscribe();
      }
    }


  deleteImport(row: LogImport) {
    //message en popup
    const modalConfirmRef = this.modalService.open(NgbdModalConfirm, {
      centered: true,
    });
    modalConfirmRef.componentInstance.title = "Suppression #" + row.nomFichier;
    modalConfirmRef.componentInstance.libelle = row.nomFichier;
    modalConfirmRef.componentInstance.queryMessage =
      "Etes-vous sûr de vouloir supprimer cet import";
    modalConfirmRef.componentInstance.description =
      '<p>Toutes les informations associées à cette Importation seront définitivement supprimées. <span class="text-danger"> Cette opération sera définitive.</span>';
    modalConfirmRef.componentInstance.btnMessage = "Oui, supprimer";

    modalConfirmRef.result.then(
      (result) => {
        console.log("modalConfirmRefResult", result);
        // on close
        this.isLoadingResults = true;
        this._logImportService
          .deleteFileImport(row.id, row.directory, row.nomFichier)
          .subscribe(
            data => {
              console.log(data);
              this.listLogImports();
            },
            error => {
              this.isLoadingResults = false;
            },
            () => {
              this.isLoadingResults = false;
            }
          );
      },
      (reason) => {
        console.log("reason", reason);
        //on dismiss
      }
    );
  }

}
